<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch1">
<div class="chapterHead"><p class="centerImage0"><img alt="image" src="images/ch1.jpg" width="4%"/></p>
</div>
<p class="para" style="text-indent: 5%;">“I look like a nerd, don’t I? Like a complete nerd,” you moan to your friend Gabe. In the mirror you see your costume and wince. “Halloween is only a few days away. I’m doomed!”</p>
<p class="para" style="text-indent: 5%;">You and Gabe have been best friends for two years. Gabe has long brown hair, wire-rimmed glasses — and a way of giving advice that sometimes bugs you.</p>
<p class="para" style="text-indent: 5%;">“You do look pretty stupid,” Gabe admits. “Where did you get that costume, anyway?”</p>
<p class="para" style="text-indent: 5%;">“It’s called Vampire in a Can,” you explain, holding up the cardboard can. “I bought it from Mr. Reuterly at Scary Stuff.”</p>
<p class="para" style="text-indent: 5%;">“I don’t believe it!” Gabe slaps his forehead. “You bought a costume from the Eyeball Man? What if he took out his glass eye — right there in the store — and <em class="italic">showed</em> it to you?”</p>
<p class="para" style="text-indent: 5%;">“He never takes out his glass eye,” you answer.</p>
<p class="para" style="text-indent: 5%;">“Okay, okay,” Gabe says. “But your costume is still ridiculous. It’s just a set of plastic fangs, a cheap little black cape, and a fake tattoo of fang marks for your neck. Isn’t there anything else in the can?”</p>
<p class="para" style="text-indent: 5%;">You pick it up and peer inside. “Hey, look!” you cry.</p>
<p class="extractLetterText" style="text-indent: 5%;"><em class="italic">Go on to <a href="#/e9780545820660_ch002">PAGE 2</a>.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545820660_ch001.vue?9cd7c642